!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?n(exports):"function"==typeof define&&define.amd?define(["exports"],n):n((t="undefined"!=typeof globalThis?globalThis:t||self).htmlToImage={})}(this,(function(t){"use strict";
function n(t,n,e,r){return new(e||(e=Promise))((function(o,i){function u(t){try{f(r.next(t))}catch(t){i(t)}}function c(t){try{f(r.throw(t))}catch(t){i(t)}}function f(t){var n;t.done?o(t.value):(n=t.value,n instanceof e?n:new e((function(t){t(n)}))).then(u,c)}f((r=r.apply(t,n||[])).next())}))}function e(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(e)throw new TypeError("Generator is already executing.");for(;u;)try{if(e=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=n.call(t,u)}catch(t){i=[6,t],r=0}finally{e=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}}var r="application/font-woff",o="image/jpeg",i={woff:r,woff2:r,ttf:"application/font-truetype",eot:"application/vnd.ms-fontobject",png:"image/png",jpg:o,jpeg:o,gif:"image/gif",tiff:"image/tiff",svg:"image/svg+xml"};function u(t){var n=function(t){var n=/\.([^./]*?)$/g.exec(t);return n?n[1]:""}(t).toLowerCase();return i[n]||""}function c(t){return-1!==t.search(/^(data:)/)}function f(t,n){return"data:"+n+";base64,"+t}var a,s=(a=0,function(){return a+=1,"u"+("0000"+(Math.random()*Math.pow(36,4)<<0).toString(36)).slice(-4)+a});function l(t){for(var n=[],e=0,r=t.length;e<r;e+=1)n.push(t[e]);return n}function h(t,n){var e=window.getComputedStyle(t).getPropertyValue(n);return parseFloat(e.replace("px",""))}function d(t){return t.toBlob?new Promise((function(n){return t.toBlob(n)})):new Promise((function(n){for(var e=window.atob(t.toDataURL().split(",")[1]),r=e.length,o=new Uint8Array(r),i=0;i<r;i+=1)o[i]=e.charCodeAt(i);n(new Blob([o],{type:"image/png"}))}))}function v(t){return new Promise((function(n,e){var r=new Image;r.onload=function(){return n(r)},r.onerror=e,r.crossOrigin="anonymous",r.decoding="sync",r.src=t}))}function p(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve().then((function(){return(new XMLSerializer).serializeToString(t)})).then(encodeURIComponent).then((function(t){return"data:image/svg+xml;charset=utf-8,"+t}))]}))}))}var g={};function m(t,n){var e=function(t){var n=t.replace(/\?.*/,"");return/ttf|otf|eot|woff2?/i.test(n)&&(n=n.replace(/.*\//,"")),n}(t);if(null!=g[e])return g[e];n.cacheBust&&(t+=(/\?/.test(t)?"&":"?")+(new Date).getTime());var r=window.fetch(t).then((function(t){return t.blob().then((function(n){return{blob:n,contentType:t.headers.get("Content-Type")||""}}))})).then((function(t){var n=t.blob,e=t.contentType;return new Promise((function(t,r){var o=new FileReader;o.onloadend=function(){return t({contentType:e,blob:o.result})},o.onerror=r,o.readAsDataURL(n)}))})).then((function(t){var n,e=t.blob;return{contentType:t.contentType,blob:(n=e,n.split(/,/)[1])}})).catch((function(e){var r="";if(n.imagePlaceholder){var o=n.imagePlaceholder.split(/,/);o&&o[1]&&(r=o[1])}var i="Failed to fetch resource: "+t;return e&&(i="string"==typeof e?e:e.message),i&&console.error(i),{blob:r,contentType:""}}));return g[e]=r,r}function w(t,n,e){var r="."+t+":"+n,o=e.cssText?function(t){var n=t.getPropertyValue("content");return t.cssText+" content: '"+n.replace(/'|"/g,"")+"';"}(e):function(t){return l(t).map((function(n){return n+": "+t.getPropertyValue(n)+(t.getPropertyPriority(n)?" !important":"")+";"})).join(" ")}(e);return document.createTextNode(r+"{"+o+"}")}function b(t,n,e){var r=window.getComputedStyle(t,e),o=r.getPropertyValue("content");if(""!==o&&"none"!==o){var i=s();try{n.className=n.className+" "+i}catch(t){return}var u=document.createElement("style");u.appendChild(w(i,e,r)),n.appendChild(u)}}function y(t){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return"data:,"===(n=t.toDataURL())?[2,Promise.resolve(t.cloneNode(!1))]:[2,v(n)]}))}))}function P(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve(t.poster).then((function(t){return m(t,r)})).then((function(n){return f(n.blob,u(t.poster)||n.contentType)})).then((function(t){return v(t)}))]}))}))}function S(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return r instanceof Element?[2,Promise.resolve().then((function(){return function(t,n){var e=window.getComputedStyle(t),r=n.style;r&&(e.cssText?r.cssText=e.cssText:l(e).forEach((function(t){r.setProperty(t,e.getPropertyValue(t),e.getPropertyPriority(t))})))}(t,r)})).then((function(){return function(t,n){b(t,n,":before"),b(t,n,":after")}(t,r)})).then((function(){return function(t,n){t instanceof HTMLTextAreaElement&&(n.innerHTML=t.value),t instanceof HTMLInputElement&&n.setAttribute("value",t.value)}(t,r)})).then((function(){return r}))]:[2,Promise.resolve(r)]}))}))}function x(t,r,o){return n(this,void 0,void 0,(function(){return e(this,(function(i){return o||!r.filter||r.filter(t)?[2,Promise.resolve(t).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return t instanceof HTMLCanvasElement?[2,y(t)]:t instanceof HTMLVideoElement&&t.poster?[2,P(t,r)]:[2,Promise.resolve(t.cloneNode(!1))]}))}))}(t,r)})).then((function(o){return function(t,r,o){var i;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){var u;return 0===(n=null!=(u=t).tagName&&"SLOT"===u.tagName.toUpperCase()&&t.assignedNodes?l(t.assignedNodes()):l((null!==(i=t.shadowRoot)&&void 0!==i?i:t).childNodes)).length||t instanceof HTMLVideoElement?[2,Promise.resolve(r)]:[2,n.reduce((function(t,n){return t.then((function(){return x(n,o)})).then((function(t){t&&r.appendChild(t)}))}),Promise.resolve()).then((function(){return r}))]}))}))}(t,o,r)})).then((function(n){return S(t,n)}))]:[2,Promise.resolve(null)]}))}))}var E=/url\((['"]?)([^'"]+?)\1\)/g,T=/url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g,C=/src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;function R(t){var n=[];return t.replace(E,(function(t,e,r){return n.push(r),t})),n.filter((function(t){return!c(t)}))}function L(t,n,e,r,o){var i=e?function(t,n){if(t.match(/^[a-z]+:\/\//i))return t;if(t.match(/^\/\//))return window.location.protocol+t;if(t.match(/^[a-z]+:/i))return t;var e=document.implementation.createHTMLDocument(),r=e.createElement("base"),o=e.createElement("a");return e.head.appendChild(r),e.body.appendChild(o),n&&(r.href=n),o.href=t,o.href}(n,e):n;return Promise.resolve(i).then((function(t){return o?o(t):m(t,r)})).then((function(t){return"string"==typeof t?f(t,u(n)):f(t.blob,u(n)||t.contentType)})).then((function(e){return t.replace((r=n.replace(/([.*+?^${}()|\[\]\/\\])/g,"\\$1"),new RegExp("(url\\(['\"]?)("+r+")(['\"]?\\))","g")),"$1"+e+"$3");var r})).then((function(t){return t}),(function(){return i}))}function N(t){return-1!==t.search(E)}function k(t,r,o){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return N(t)?(n=function(t,n){var e=n.preferredFontFormat;return e?t.replace(C,(function(t){for(;;){var n=T.exec(t)||[],r=n[0],o=n[2];if(!o)return"";if(o===e)return"src: "+r+";"}})):t}(t,o),[2,Promise.resolve(n).then(R).then((function(t){return t.reduce((function(t,n){return t.then((function(t){return L(t,n,r,o)}))}),Promise.resolve(n))}))]):[2,Promise.resolve(t)]}))}))}function A(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(o){return t instanceof Element?[2,Promise.resolve(t).then((function(t){return function(t,r){var o;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return(n=null===(o=t.style)||void 0===o?void 0:o.getPropertyValue("background"))?[2,Promise.resolve(n).then((function(t){return k(t,null,r)})).then((function(n){return t.style.setProperty("background",n,t.style.getPropertyPriority("background")),t}))]:[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return t instanceof HTMLImageElement&&!c(t.src)||t instanceof SVGImageElement&&!c(t.href.baseVal)?(n=t instanceof HTMLImageElement?t.src:t.href.baseVal,[2,Promise.resolve(n).then((function(t){return m(t,r)})).then((function(t){return f(t.blob,u(n)||t.contentType)})).then((function(n){return new Promise((function(e,r){t.onload=e,t.onerror=r,t instanceof HTMLImageElement?(t.srcset="",t.src=n):t.href.baseVal=n}))})).then((function(){return t}),(function(){return t}))]):[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n,o;return e(this,(function(e){return n=l(t.childNodes),o=n.map((function(t){return A(t,r)})),[2,Promise.all(o).then((function(){return t}))]}))}))}(t,r)}))]:[2,Promise.resolve(t)]}))}))}var I={};function M(t){var n=I[t];if(null!=n)return n;var e=window.fetch(t).then((function(n){return{url:t,cssText:n.text()}}));return I[t]=e,e}function D(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,t.cssText.then((function(n){var e=n,r=/url\(["']?([^"')]+)["']?\)/g,o=(e.match(/url\([^)]+\)/g)||[]).map((function(n){var o=n.replace(r,"$1");return o.startsWith("https://")||(o=new URL(o,t.url).href),window.fetch(o).then((function(t){return t.blob()})).then((function(t){return new Promise((function(r,o){var i=new FileReader;i.onloadend=function(){e=e.replace(n,"url("+i.result+")"),r([n,i.result])},i.onerror=o,i.readAsDataURL(t)}))}))}));return Promise.all(o).then((function(){return e}))}))]}))}))}function V(t){if(null==t)return[];for(var n=[],e=t.replace(/(\/\*[\s\S]*?\*\/)/gi,""),r=new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})","gi");;){if(null===(u=r.exec(e)))break;n.push(u[0])}e=e.replace(r,"");for(var o=/@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi,i=new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})","gi");;){var u;if(null===(u=o.exec(e))){if(null===(u=i.exec(e)))break;o.lastIndex=i.lastIndex}else i.lastIndex=o.lastIndex;n.push(u[0])}return n}function H(t){return t.filter((function(t){return t.type===CSSRule.FONT_FACE_RULE})).filter((function(t){return N(t.style.getPropertyValue("src"))}))}function U(t){return n(this,void 0,void 0,(function(){return e(this,(function(r){return[2,new Promise((function(n,e){null==t.ownerDocument&&e(new Error("Provided element is not within a Document")),n(l(t.ownerDocument.styleSheets))})).then((function(t){return function(t){return n(this,void 0,void 0,(function(){var n,r;return e(this,(function(e){return n=[],r=[],t.forEach((function(n){if("cssRules"in n)try{l(n.cssRules).forEach((function(t,e){if(t.type===CSSRule.IMPORT_RULE){var o=e+1,i=M(t.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){try{n.insertRule(t,t.startsWith("@import")?o+=1:n.cssRules.length)}catch(n){console.error("Error inserting rule from remote css",{rule:t,error:n})}}))})).catch((function(t){console.error("Error loading remote css",t.toString())}));r.push(i)}}))}catch(o){var e=t.find((function(t){return null==t.href}))||document.styleSheets[0];null!=n.href&&r.push(M(n.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){e.insertRule(t,n.cssRules.length)}))})).catch((function(t){console.error("Error loading remote stylesheet",t.toString())}))),console.error("Error inlining remote css file",o.toString())}})),[2,Promise.all(r).then((function(){return t.forEach((function(t){if("cssRules"in t)try{l(t.cssRules).forEach((function(t){n.push(t)}))}catch(n){console.error("Error while reading CSS rules from "+t.href,n.toString())}})),n}))]}))}))}(t)})).then(H)]}))}))}function j(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,U(t).then((function(t){return Promise.all(t.map((function(t){var n=t.parentStyleSheet?t.parentStyleSheet.href:null;return k(t.cssText,n,r)})))})).then((function(t){return t.join("\n")}))]}))}))}function F(t,n){void 0===n&&(n={});var e=n.width||function(t){var n=h(t,"border-left-width"),e=h(t,"border-right-width");return t.clientWidth+n+e}(t),r=n.height||function(t){var n=h(t,"border-top-width"),e=h(t,"border-bottom-width");return t.clientHeight+n+e}(t);return{width:e,height:r}}function B(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var o,i,u;return e(this,(function(c){return o=F(t,r),i=o.width,u=o.height,[2,Promise.resolve(t).then((function(t){return x(t,r,!0)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,(null!=r.fontEmbedCSS?Promise.resolve(r.fontEmbedCSS):j(t,r)).then((function(n){var e=document.createElement("style"),r=document.createTextNode(n);return e.appendChild(r),t.firstChild?t.insertBefore(e,t.firstChild):t.appendChild(e),t}))]}))}))}(t,r)})).then((function(t){return A(t,r)})).then((function(t){return function(t,n){var e=t.style;n.backgroundColor&&(e.backgroundColor=n.backgroundColor),n.width&&(e.width=n.width+"px"),n.height&&(e.height=n.height+"px");var r=n.style;return null!=r&&Object.keys(r).forEach((function(t){e[t]=r[t]})),t}(t,r)})).then((function(t){return function(t,r,o){return n(this,void 0,void 0,(function(){var n,i,u;return e(this,(function(e){return n="http://www.w3.org/2000/svg",i=document.createElementNS(n,"svg"),u=document.createElementNS(n,"foreignObject"),i.setAttribute("width",""+r),i.setAttribute("height",""+o),i.setAttribute("viewBox","0 0 "+r+" "+o),u.setAttribute("width","100%"),u.setAttribute("height","100%"),u.setAttribute("x","0"),u.setAttribute("y","0"),u.setAttribute("externalResourcesRequired","true"),i.appendChild(u),u.appendChild(t),[2,p(i)]}))}))}(t,i,u)}))]}))}))}var O=16384;function $(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,B(t,r).then(v).then((function(n){var e=document.createElement("canvas"),o=e.getContext("2d"),i=r.pixelRatio||function(){var t,n;try{n=process}catch(t){}var e=n&&n.env?n.env.devicePixelRatio:null;return e&&(t=parseInt(e,10),Number.isNaN(t)&&(t=1)),t||window.devicePixelRatio||1}(),u=F(t,r),c=u.width,f=u.height,a=r.canvasWidth||c,s=r.canvasHeight||f;return e.width=a*i,e.height=s*i,r.skipAutoScale||function(t){(t.width>O||t.height>O)&&(t.width>O&&t.height>O?t.width>t.height?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O):t.width>O?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O))}(e),e.style.width=""+a,e.style.height=""+s,r.backgroundColor&&(o.fillStyle=r.backgroundColor,o.fillRect(0,0,e.width,e.height)),o.drawImage(n,0,0,e.width,e.height),e}))]}))}))}t.getFontEmbedCSS=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,j(t,r)]}))}))},t.toBlob=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then(d)]}))}))},t.toCanvas=$,t.toJpeg=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL("image/jpeg",r.quality||1)}))]}))}))},t.toPixelData=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var n,o,i;return e(this,(function(e){return n=F(t,r),o=n.width,i=n.height,[2,$(t,r).then((function(t){return t.getContext("2d").getImageData(0,0,o,i).data}))]}))}))},t.toPng=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL()}))]}))}))},t.toSvg=B,Object.defineProperty(t,"__esModule",{value:!0})}));

const saveModalBtn = document.getElementById('saveModal')
saveModalBtn.addEventListener('click' , (e) => {
    htmlToImage.toJpeg(document.getElementById('reportModal'), { quality: 0.95 })
  .then(function (dataUrl) {
    var link = document.createElement('a');
    var rptFileName = identifier.patient
    link.download = `${rptFileName}.jpeg`;
    link.href = dataUrl;
    link.click();
  });
    console.log(e);
});

const newWorkBtn = document.querySelector("#worksheets-btn");
newWorkBtn.addEventListener("click", (e) => {
  showPatID();
  console.log(e);
});
function showPatID() {
  document.getElementById("patientId").style.display = "block";
}



const togMenuBtn = document.querySelector("#togMenu");

togMenuBtn.addEventListener("click", (e) => {
  myFunction();
  console.log(e);
});
function myFunction() {
  var x = document.getElementById("navDemo");
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else {
    x.className = x.className.replace(" w3-show", "");
  }
}
function printReport() {
  document.getElementById("nonPrintable").className += "noPrint";
  window.print();
}
const printReportBtn = document.querySelector("#printReport");
printReportBtn.addEventListener("click", (e) => {
  printReport();
  console.log(e);
});

function showReportModal() {
  document.getElementById("reportModal").style.display = "block";
}

window.onclick = function (event) {
  if (
    event.target.id == "id01" ||
    event.target.id == "id02" ||
    event.target.id == "id03" ||
    event.target.id == "id04" ||
    event.target.id == "id05" ||
    event.target.id == "reportModal" ||
    event.target.id == "patientId" ||
    event.target.id == "dhrInput"
  ) {
    document.getElementById(event.target.id).style.display = "none";
  }
};
const history = {
    patID : "",
    
    title: "Ultrasound",
    side : '',
    
    
    symptoms: "",
    roi :'',
    custom : '',
    
    
    reportLine :function () {
      history.reportLine = clinReport();
    }
  };
  
  
  const identifier =  {
    patient: "",
    sono : "",
  }
  
  function getPatID() {
  
    document.querySelector("#patIdLine").innerHTML = boldString("Patient Identifier  -  ",'Patient Identifier') + identifier.patient
      document.querySelector("#sonoIdLine").innerHTML = boldString('Sonographer  -  ','Sonographer') + identifier.sono;
       
      document.getElementById("patientId").style.display = "none";
    }
    
    const pDSubBtn = document.querySelector("#patDetSub");
    pDSubBtn.addEventListener("click", (e) => {
      
      identifier.patient = document.getElementById('patDet').value;
      identifier.sono = document.getElementById('sono').value;
      getPatID();
      if (hallux.reported === true) {
          halluxPopulate();
      } else {
          populate();
      }
      console.log(e);
    });
  
  
   
  const hisCusText = document.querySelector('#hisCus')
  hisCusText.addEventListener("focusout", (e) => {
      history.custom = e.target.value
  });

  const hisSideBtn = document.querySelectorAll(".hisSid");
  hisSideBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.side = e.target.id;
      console.log(e);
    });
  });  
  const hisRoiBtn = document.querySelectorAll(".hisRoi");
  hisRoiBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.roi = e.target.id;
      console.log(e);
    });
  }); 
  
  const hisSymBtn = document.querySelectorAll(".hisSym");
  hisSymBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.symptoms = e.target.id;
      console.log(e);
    });
  });
  
  
  
  function clinReport() {
    
       {
        history.reportLine = history.roi + history.symptoms  + history.custom
      }
      
  }

  
  function addClin() {
    clinReport();
    
    document.getElementById("hisRpt").innerHTML = boldString("Clinical Details - ","Clinical Details") + `${history.reportLine}`;
   }
  
  /*
  const hisRepBtn = document.querySelector("#hisRep");
  hisRepBtn.addEventListener("click", () => {
    
    addClin();
    showReportModal();
  });
  */
  function showDiv(id) {
    var x = document.getElementById(id);
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else { 
      x.className = x.className.replace(" w3-show", "");
    }
  }

function showCDDiv() {
  var x = document.getElementById('clinDet');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showRFFDiv() {
  var x = document.getElementById('rightForefoot');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showLFFDiv() {
    var x = document.getElementById('leftForefoot');
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else { 
      x.className = x.className.replace(" w3-show", "");
    }
  }

const hallux = {
    id : 'MTP1',
    name : '1st MTPJ',
    side : '',
    reportSide : '',
    reported : false,
    effusion : 'No effusion or synovitis. ',
    extensor : 'No extensor tendon abnormality. ',
    flexor : 'FHL normal. ',
    mcl : '',
    sesamoid : 'Sesamoids appear normal. ',
    plantar : 'No plantar plate tear. ',
    plantarText : '',
    sesPhal : '',
    ipj : '',
    fatPadDim : '',
    fatPad : '',
    other : '',

}
function addHallux(obj) {
   addReportSide(hallux);
    document.getElementById(`${obj.reportSide}${obj.id}Rpt`).innerHTML = `${boldString(obj.name +'  -  ',obj.name)}
    ${obj.effusion} ${obj.extensor} ${obj.flexor} ${obj.mcl} ${obj.sesamoid} ${obj.plantar} ${obj.plantarText} ${obj.sesPhal} ${obj.fatPadDim} ${obj.fatPad}` ;
    if (obj.ipj !== '' || obj.other !== '') {
     document.getElementById(`${obj.reportSide}${obj.id}Rpt2`).innerHTML = `${obj.ipj} ${obj.other}`;
    } 
    } 
function addReportSide(obj) {
 if (obj.side === 'Right ') {
     obj.reportSide = 'right';
 } if (obj.side === 'Left ') {
    obj.reportSide = 'left';
} if (obj.side === '') {
    checkSide();
}
}  

const halluxText = document.querySelectorAll('.halluxText')       
halluxText.forEach((element) => {
   element.addEventListener('keyup', function (e) {
   let property = this.dataset.prop;
   hallux[property] = e.target.value;
       console.log(e);
   });
});
const halluxBtn = document.querySelectorAll(".halluxBtn")
halluxBtn.forEach((button) => {
 button.addEventListener("click", function  (e)  {
 property = this.dataset.prop;
   hallux[property] = e.target.id;
   if (hallux.side !== "") {
       document.querySelector('#halluxReq').style.display = 'none';
   }
   console.log(e);
 })
})


const halluxRepBtn = document.querySelector("#halluxRep");
      halluxRepBtn.addEventListener("click", (e) => {
        hallux.reported = true;
        halluxPopulate();
        console.log(e);
      });

function halluxPopulate() {
        checkID();
        if (identifier.patient === '' || identifier.sono === '' ) {
          return
         }
        addHalluxTitle();
        addClin();
        addHallux(hallux);
        showReportModal();
}
function addHalluxTitle() {
    
    if (hallux.side === 'Right ' )  {
        document.getElementById('rightSubTitleRpt').innerHTML = `${hallux.side} Hallux`;
     }
      if (hallux.side === 'Left ' )  {
         document.getElementById('leftSubTitleRpt').innerHTML = `${hallux.side} Hallux`;
      }
      else {
          checkSide('halluxSection')
      }
     }

function addTitle() {
  if (history.region !== '' )  {
       document.getElementById('rightSubTitleRpt').innerHTML = `${history.region}`;
    } else if (history.region !== '')  {
        document.getElementById('leftSubTitleRpt').innerHTML = `${history.region}`;
     }
     else  {
       checkSide('clinSection');
    }
  }

function checkSide(id) {
document.getElementById(id).click();
};
const rightMTP = {
  effNorm : 'No effusion or synovitis. ',
  effusion : '',
  roi  : '',
  effText :'',
  tendons : 'No flexor or extensor tendon abnormality. ',
  
  reportLine : function() {
    rightMTP.reportLine = rightMTPReport();
  },
}

const rightMTRoiBtn = document.querySelectorAll(".rightMTRoi");
rightMTRoiBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            rightMTP.roi = e.target.id;
            console.log(e);
          });
        });
const rightMTEffBtn = document.querySelectorAll(".rightMTEff");
rightMTEffBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            rightMTP.effusion = e.target.id;
            rightMTP.effNorm = '';
            console.log(e);
          });
        });
        const rightMTEffText = document.querySelector('#rightMTEffText')
        rightMTEffText.addEventListener('focusout', (e) => {
            rightMTP.effText = e.target.value;
            rightMTP.effNorm = '';
            console.log(e);
          })
            
          const rightMTTendText = document.querySelector('#rightMTTendText')
          rightMTTendText.addEventListener('focusout', (e) => {
              rightMTP.tendons = e.target.value;
              console.log(e);
            })  
            function rightMTPReport() {
                
                    rightMTP.reportLine =  rightMTP.effNorm   + rightMTP.effusion + rightMTP.roi + rightMTP.effText + ' ' + rightMTP.tendons 
                }

                const rightPlantar = {
                    norm : 'No plantar plate tear. ',
                    tear : '' ,
                    roi: '',
                    text : '',
                    reportLine : function() {
                        rightPlantar.reportLine = rightPlantarReport();
                      },
                }
                const rightPlanRoiBtn = document.querySelectorAll(".rightPlanRoi");
                rightPlanRoiBtn.forEach((button) => {
                          button.addEventListener("click", (e) => {
                            rightPlantar.roi = e.target.id;
                            rightPlantar.norm = '';
                            console.log(e);
                          });
                        });
                const rightPlanTearBtn = document.querySelectorAll(".rightPlanTear");
                rightPlanTearBtn.forEach((button) => {
                          button.addEventListener("click", (e) => {
                            rightPlantar.tear = e.target.id;
                            rightPlantar.norm = '';
                            console.log(e);
                          });
                        });
                        const rightPlanText = document.querySelector('#rightPlanText')
                        rightPlanText.addEventListener('focusout', (e) => {
                            rightPlantar.text = e.target.value;
                            rightPlantar.norm = '';
                            console.log(e);
                          })              
                function rightPlantarReport() {
                
                    rightPlantar.reportLine =  rightPlantar.norm  +rightPlantar.roi + rightPlantar.tear +' ' +rightPlantar.text
                }
const rightMTBone = {
    findings : 'No evidence of MT bone stress',
    roi : '',
    secRoi: '',
    reportLine : function() {
        this.reportLine = rightMTBoneReport()
    }
}           
function rightMTBoneReport() {
 rightMTBone.reportLine =  rightMTBone.roi + rightMTBone.findings + '.  '
    if (rightMTBone.secRoi !== '') {
    rightMTBone.reportLine += ' There are less pronounced changes suggestive of lower grade bone stress at the ' + rightMTBone.secRoi 
}
}

const rightMTBonFinBtn = document.querySelectorAll('.rightMTBonFin')
rightMTBonFinBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightMTBone.findings = e.target.id;
        console.log(e);
    });
});
const rightMTBonRoiBtn = document.querySelectorAll('.rightMTBonRoi')
rightMTBonRoiBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightMTBone.roi = e.target.id;
        console.log(e);
    });
});
const rightMTBonSecRoiBtn = document.querySelectorAll('.rightMTBonSecRoi')
rightMTBonSecRoiBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightMTBone.secRoi = e.target.id;
        console.log(e);
    });
});
const rightSpace = {
    findings : 'No IMT bursitis or Mortons neuroma',
    first : {
        path : '',
        dim: '',
        reportLine : '',
    },
    second: {
        path : '',
        dim: '',
        reportLine : '',
    },
    third: {
        path :'',
        dim : '',
        reportLine :'',
    },
    other : '',
}
const rightSpaFirstText = document.querySelector('#rightSpaFirstText')
rightSpaFirstText.addEventListener('focusout', (e) => {
    rightSpace.first.dim = e.target.value;
    rightSpace.findings = '';
    console.log(e);
  })    
const rightSpaFirstBtn = document.querySelectorAll('.rightSpaFirst')
rightSpaFirstBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightSpace.first.path = e.target.id;
        rightSpace.findings = '';
        console.log(e);
});
});
const rightSpaSecondText = document.querySelector('#rightSpaSecondText')
rightSpaSecondText.addEventListener('focusout', (e) => {
    rightSpace.second.dim = e.target.value;
    rightSpace.findings = '';
    console.log(e);
  })    
const rightSpaSecondBtn = document.querySelectorAll('.rightSpaSecond')
rightSpaSecondBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightSpace.second.path = e.target.id;
        rightSpace.findings = '';
        console.log(e);
  });
});
  const rightSpaThirdText = document.querySelector('#rightSpaThirdText')
rightSpaThirdText.addEventListener('focusout', (e) => {
    rightSpace.third.dim = e.target.value;
    rightSpace.findings = '';
    console.log(e);
  })    
const rightSpaThirdBtn = document.querySelectorAll('.rightSpaThird')
rightSpaThirdBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightSpace.third.path = e.target.id;
        rightSpace.findings = '';
        console.log(e);
  });
});
const rightSpaOtherText = document.querySelector('#rightSpaOtherText')
rightSpaOtherText.addEventListener('focusout', (e) => {
    rightSpace.other = e.target.value;
    rightSpace.findings = '';
    console.log(e);
  })    
function rightFirstReport() {
    if (rightSpace.first.dim ===  '' && rightSpace.second.dim === '' && rightSpace.third.dim === '' && rightSpace.other === '') {
        rightSpace.first.reportLine = rightSpace.findings 
    } else 
 rightSpace.first.reportLine = rightSpace.first.dim + rightSpace.first.path
}
function rightSecondReport() {
    
  rightSpace.second.reportLine = rightSpace.second.dim + rightSpace.second.path
  }
  function rightThirdReport() {
    
  rightSpace.third.reportLine = rightSpace.third.dim + rightSpace.third.path
  }
function AddRightSpaces() {
    rightFirstReport();
    rightSecondReport();
    rightThirdReport()
    if (rightSpace.first.reportLine !== '') {
        document.getElementById("rightMTS1Rpt").innerHTML = boldString("Webspaces   -  ","Webspaces") + rightSpace.findings;
    } if (rightSpace.first.path !== '') {
        document.getElementById("rightMTS1Rpt").innerHTML = boldString("1st Webspace   -  ","1st Webspace") + rightSpace.first.reportLine;
    } if (rightSpace.second.path !== '') {
        document.getElementById("rightMTS2Rpt").innerHTML = boldString("2nd Webspace   -  ","2nd Webspace") + rightSpace.second.reportLine;
    } if (rightSpace.third.path !== '') {
        document.getElementById("rightMTS3Rpt").innerHTML = boldString("3rd Webspace   -  ","3rd Webspace") + rightSpace.third.reportLine;
    } if (rightSpace.other !== '') {
        document.getElementById("rightMTS4Rpt").innerHTML = rightSpace.other;
}
}


function addRightMTP() {
     rightMTPReport();
     rightPlantarReport();
     rightMTBoneReport();
     rightFatReport();
     document.getElementById("rightFatRpt").innerHTML = boldString("Plantar Fat Pad  -  ","Plantar Fat Pad") + rightFat.reportLine;
     document.getElementById("rightMTBoneRpt").innerHTML = boldString("Metatarsals  -  ","Metatarsals") + rightMTBone.reportLine;
      document.getElementById("rightMTPRpt").innerHTML = boldString("MTP Joints  -  ","MTP Joints") + rightMTP.reportLine;
      document.getElementById("rightPlanRpt").innerHTML = boldString("Plantar Plates  -  ","Plantar Plates") + rightPlantar.reportLine;
     } 
const rightFat = {
    finding : 'Normal appearance. ',
    roi : '',
    secRoi : '',
    other : '',
    reportLine : function() {
        this.reportLine = rightFatReport();
    }
}
const rightFatBtn = document.querySelectorAll('.rightFat')
rightFatBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightFat.finding = e.target.id;
        console.log(e);
});
});            
const rightFatRoiBtn = document.querySelectorAll('.rightFatRoi')
rightFatRoiBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightFat.roi = e.target.id;
        console.log(e);
});
});
const rightFatSecRoiBtn = document.querySelectorAll('.rightFatSecRoi')
rightFatSecRoiBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
        rightFat.secRoi = e.target.id;
        console.log(e);
});
});
const rightFatOtherText = document.querySelector('#rightFatOtherText')
rightFatOtherText.addEventListener('focusout', (e) => {
    rightFat.other = e.target.value;
    console.log(e);
  }) 
  function rightFatReport() {
    if (rightFat.finding === 'Normal appearance. ') {
      rightFat.reportLine = rightFat.finding   
     } else if (rightFat.finding === 'Space occupying hypoechoic thickening consistent with adventitious bursa ') {
         rightFat.reportLine = rightFat.other + ' ' +rightFat.finding + ' over the ' + rightFat.roi + '. '
     } else if (rightFat.roi !== '') {
    rightFat.reportLine = rightFat.finding + ' over the ' + rightFat.roi + '  '
     if (rightFat.secRoi !== '')  {
         rightFat.reportLine += ' Less promiment findings over the ' + rightFat.secRoi + '  '
     if (rightFat.other !== '') {
    rightFat.reportLine += rightFat.other
  }}} 
  }
const leftMTP = {
    effNorm : 'No effusion or synovitis. ',
    effusion : '',
    roi  : '',
    effText :'',
    tendons : 'No flexor or extensor tendon abnormality. ',
   
    reportLine : function() {
      leftMTP.reportLine = leftMTPReport();
    },
  }
  
  const leftMTRoiBtn = document.querySelectorAll(".leftMTRoi");
  leftMTRoiBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              leftMTP.roi = e.target.id;
              console.log(e);
            });
          });
  const leftMTEffBtn = document.querySelectorAll(".leftMTEff");
  leftMTEffBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              leftMTP.effusion = e.target.id;
              leftMTP.effNorm = '';
              console.log(e);
            });
          });
          const leftMTEffText = document.querySelector('#leftMTEffText')
          leftMTEffText.addEventListener('focusout', (e) => {
              leftMTP.effText = e.target.value;
              leftMTP.effNorm = '';
              console.log(e);
            })
                 
            const leftMTTendText = document.querySelector('#leftMTTendText')
            leftMTTendText.addEventListener('focusout', (e) => {
                leftMTP.tendons = e.target.value;
                console.log(e);
              })  
              function leftMTPReport() {
                  
                      leftMTP.reportLine =  leftMTP.effNorm   + leftMTP.effusion + leftMTP.roi + leftMTP.effText + ' ' + leftMTP.tendons
                  }
  
                  const leftPlantar = {
                      norm : 'No plantar plate tear. ',
                      tear : '' ,
                      roi: '',
                      text : '',
                      reportLine : function() {
                          leftPlantar.reportLine = leftPlantarReport();
                        },
                  }
                  const leftPlanRoiBtn = document.querySelectorAll(".leftPlanRoi");
                  leftPlanRoiBtn.forEach((button) => {
                            button.addEventListener("click", (e) => {
                              leftPlantar.roi = e.target.id;
                              leftPlantar.norm = '';
                              console.log(e);
                            });
                          });
                  const leftPlanTearBtn = document.querySelectorAll(".leftPlanTear");
                  leftPlanTearBtn.forEach((button) => {
                            button.addEventListener("click", (e) => {
                              leftPlantar.tear = e.target.id;
                              leftPlantar.norm = '';
                              console.log(e);
                            });
                          });
                          const leftPlanText = document.querySelector('#leftPlanText')
                          leftPlanText.addEventListener('focusout', (e) => {
                              leftPlantar.text = e.target.value;
                              leftPlantar.norm = '';
                              console.log(e);
                            })              
                  function leftPlantarReport() {
                  
                      leftPlantar.reportLine =  leftPlantar.norm  +leftPlantar.roi + leftPlantar.tear +' ' +leftPlantar.text
                  }
  const leftMTBone = {
      findings : 'No evidence of MT bone stress',
      roi : '',
      secRoi: '',
      reportLine : function() {
          this.reportLine = leftMTBoneReport()
      }
  }           
  function leftMTBoneReport() {
   leftMTBone.reportLine =  leftMTBone.roi + leftMTBone.findings + '.  '
      if (leftMTBone.secRoi !== '') {
      leftMTBone.reportLine += ' There are less pronounced changes suggestive of lower grade bone stress at the ' + leftMTBone.secRoi 
  }
  }
  
  const leftMTBonFinBtn = document.querySelectorAll('.leftMTBonFin')
  leftMTBonFinBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftMTBone.findings = e.target.id;
          console.log(e);
      });
  });
  const leftMTBonRoiBtn = document.querySelectorAll('.leftMTBonRoi')
  leftMTBonRoiBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftMTBone.roi = e.target.id;
          console.log(e);
      });
  });
  const leftMTBonSecRoiBtn = document.querySelectorAll('.leftMTBonSecRoi')
  leftMTBonSecRoiBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftMTBone.secRoi = e.target.id;
          console.log(e);
      });
  });
  const leftSpace = {
      findings : 'No IMT bursitis or Mortons neuroma',
      first : {
          path : '',
          dim: '',
          reportLine : '',
      },
      second: {
          path : '',
          dim: '',
          reportLine : '',
      },
      third: {
          path :'',
          dim : '',
          reportLine :'',
      },
      other : '',
  }
  const leftSpaFirstText = document.querySelector('#leftSpaFirstText')
  leftSpaFirstText.addEventListener('focusout', (e) => {
      leftSpace.first.dim = e.target.value;
      leftSpace.findings = '';
      console.log(e);
    })    
  const leftSpaFirstBtn = document.querySelectorAll('.leftSpaFirst')
  leftSpaFirstBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftSpace.first.path = e.target.id;
          leftSpace.findings = '';
          console.log(e);
  });
  });
  const leftSpaSecondText = document.querySelector('#leftSpaSecondText')
  leftSpaSecondText.addEventListener('focusout', (e) => {
      leftSpace.second.dim = e.target.value;
      leftSpace.findings = '';
      console.log(e);
    })    
  const leftSpaSecondBtn = document.querySelectorAll('.leftSpaSecond')
  leftSpaSecondBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftSpace.second.path = e.target.id;
          leftSpace.findings = '';
          console.log(e);
    });
  });
    const leftSpaThirdText = document.querySelector('#leftSpaThirdText')
  leftSpaThirdText.addEventListener('focusout', (e) => {
      leftSpace.third.dim = e.target.value;
      leftSpace.findings = '';
      console.log(e);
    })    
  const leftSpaThirdBtn = document.querySelectorAll('.leftSpaThird')
  leftSpaThirdBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftSpace.third.path = e.target.id;
          leftSpace.findings = '';
          console.log(e);
    });
  });
  const leftSpaOtherText = document.querySelector('#leftSpaOtherText')
  leftSpaOtherText.addEventListener('focusout', (e) => {
      leftSpace.other = e.target.value;
      leftSpace.findings = '';
      console.log(e);
    })    
  function leftFirstReport() {
      if (leftSpace.first.dim ===  '' && leftSpace.second.dim === '' && leftSpace.third.dim === '' && leftSpace.other === '') {
          leftSpace.first.reportLine = leftSpace.findings 
      } else 
   leftSpace.first.reportLine = leftSpace.first.dim + leftSpace.first.path
  }
  function leftSecondReport() {
      
    leftSpace.second.reportLine = leftSpace.second.dim + leftSpace.second.path
    }
    function leftThirdReport() {
      
    leftSpace.third.reportLine = leftSpace.third.dim + leftSpace.third.path
    }
  function AddLeftSpaces() {
      leftFirstReport();
      leftSecondReport();
      leftThirdReport()
      if (leftSpace.first.reportLine !== '') {
          document.getElementById("leftMTS1Rpt").innerHTML = boldString("Webspaces   -  ","Webspaces") + leftSpace.findings;
      } if (leftSpace.first.path !== '') {
          document.getElementById("leftMTS1Rpt").innerHTML = boldString("1st Webspace   -  ","1st Webspace") + leftSpace.first.reportLine;
      } if (leftSpace.second.path !== '') {
          document.getElementById("leftMTS2Rpt").innerHTML = boldString("2nd Webspace   -  ","2nd Webspace") + leftSpace.second.reportLine;
      } if (leftSpace.third.path !== '') {
          document.getElementById("leftMTS3Rpt").innerHTML = boldString("3rd Webspace   -  ","3rd Webspace") + leftSpace.third.reportLine;
      } if (leftSpace.other !== '') {
          document.getElementById("leftMTS4Rpt").innerHTML = leftSpace.other;
  }
  }
  
  
  function addLeftMTP() {
       leftMTPReport();
       leftPlantarReport();
       leftMTBoneReport();
       leftFatReport();
       document.getElementById("leftFatRpt").innerHTML = boldString("Plantar Fat Pad  -  ","Plantar Fat Pad") + leftFat.reportLine;
       document.getElementById("leftMTBoneRpt").innerHTML = boldString("Metatarsals  -  ","Metatarsals") + leftMTBone.reportLine;
        document.getElementById("leftMTPRpt").innerHTML = boldString("MTP Joints  -  ","MTP Joints") + leftMTP.reportLine;
        document.getElementById("leftPlanRpt").innerHTML = boldString("Plantar Plates  -  ","Plantar Plates") + leftPlantar.reportLine;
       } 
  const leftFat = {
      finding : 'Normal appearance. ',
      roi : '',
      secRoi : '',
      other : '',
      reportLine : function() {
          this.reportLine = leftFatReport();
      }
  }
  const leftFatBtn = document.querySelectorAll('.leftFat')
  leftFatBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftFat.finding = e.target.id;
          console.log(e);
  });
  });            
  const leftFatRoiBtn = document.querySelectorAll('.leftFatRoi')
  leftFatRoiBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftFat.roi = e.target.id;
          console.log(e);
  });
  });
  const leftFatSecRoiBtn = document.querySelectorAll('.leftFatSecRoi')
  leftFatSecRoiBtn.forEach((button) => {
      button.addEventListener('click', (e) => {
          leftFat.secRoi = e.target.id;
          console.log(e);
  });
  });
  const leftFatOtherText = document.querySelector('#leftFatOtherText')
  leftFatOtherText.addEventListener('focusout', (e) => {
      leftFat.other = e.target.value;
      console.log(e);
    }) 
  function leftFatReport() {
      if (leftFat.finding === 'Normal appearance. ') {
        leftFat.reportLine = leftFat.finding   
       } else if (leftFat.finding === 'Space occupying hypoechoic thickening consistent with adventitious bursa ') {
           leftFat.reportLine = leftFat.other + ' ' +leftFat.finding + ' over the ' + leftFat.roi + '. '
       } else if (leftFat.roi !== '') {
      leftFat.reportLine = leftFat.finding + ' over the ' + leftFat.roi + '  '
       if (leftFat.secRoi !== '')  {
           leftFat.reportLine += ' Less promiment findings over the ' + leftFat.secRoi + '  '
       if (leftFat.other !== '') {
      leftFat.reportLine += leftFat.other
    }}} 
}
function boldString(str, substr) {
    var strRegExp = new RegExp(substr, 'g');
    return str.replace(strRegExp, '<b><i>'+substr+'</i></b>');
  }

  const rightFootRepBtn = document.querySelector("#rightFootRep");
  rightFootRepBtn.addEventListener("click", () => {
    checkID();
    addClin();
    document.getElementById("rightSubTitleRpt").innerHTML = "Right Foot";
    addRightMTP();
    AddRightSpaces();
    showReportModal();
  });
  const leftFootRepBtn = document.querySelector("#leftFootRep");
  leftFootRepBtn.addEventListener("click", () => {
    checkID();
    addClin();
    document.getElementById("leftSubTitleRpt").innerHTML = "Left Foot";
    addLeftMTP();
    AddLeftSpaces();
    showReportModal();
  }); 
  const reOpenWSBtn = document.querySelector("#savRep");
  reOpenWSBtn.addEventListener("click", () => {
    showReportModal();
  });
  
function checkID() {
 if (identifier.patient === '' || identifier.sono === '') {
  showPatID();
 }
}
   
   function populate() {
     checkID();
     if (identifier.patient === '' || identifier.sono === '' ) {
      return
     }
     addClin();
     showReportModal();
     }



